<template>
  <Dialog :show.sync="visible" title="添加标注">
    <template v-slot:body>
      <div class="dialog-body">
        <div>
          <el-form size="small" ref="form" :model="form" :rules="rules" label-width="auto" >
            <el-form-item label="标注信息" prop="mark">
              <el-input v-model="form.mark" :placeholder="$t('PleaseInput')"/>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </template>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('cancel_k') }}</el-button>
      <el-button size="small" type="primary" @click="save">{{ $t('confirm_k') }}</el-button>
    </div>
  </Dialog>
</template>
<script>
export default {
  data() {
    return {
      visible:false,
      form: {
        mark: '',
      },
      rules: {
        mark: {required: true, message: this.$t('PleaseInput'), trigger: 'blur'},
      },
    }
  },
  methods: {
    open(mark){
      this.visible = true
      this.form.mark = mark
    },
    save() {
      this.$refs.form.validate((v) => {
        if (v) {
          this.$emit('success',this.form)
          this.visible = false
        }
      });
    },
  }
}
</script>
